// Mock data for Hybrid Training Club — Hyrox Toulouse / Colomiers
// NOTE: all content here is mocked for the frontend-only build.

export const CONTACT_EMAIL = 'contact@hybrid-training-club.com';

// Optimized 128px logo (was 758 KB @ 1254px; displayed ≤ 44px). Same artwork,
// ~14 KB — big mobile payload win since the logo loads in navbar + footer everywhere.
export const LOGO = '/logo-h-128.png';

// Image widths tuned for mobile-first delivery. Thumbnails (stations, team,
// courses, club gallery, testimonials) render ≤ ~350px CSS px, so w=800 stays
// crisp on 2x screens while cutting payload ~2-3x vs the original w=1200/1400.
// Large hero/feature images keep w=1100 for sharpness on wide viewports.
export const IMAGES = {
  heroAthlete: '/img/hero-athlete.jpg',
  // Vraies photos de compétition Hyrox (assets de marque Hybrid) — servies en local.
  hxRunStart: '/img/hyrox-run-start.jpg',
  hxSledPush: '/img/hyrox-sled-push.jpg',
  hxSkierg: '/img/hyrox-skierg.jpg',
  hxSledPull: '/img/hyrox-sled-pull.jpg',
  hxRameur: '/img/hyrox-rameur.jpg',
  hxKbCarry: '/img/hyrox-kb-carry.jpg',
  hxSbLunges: '/img/hyrox-sb-lunges.jpg',
  hxRunFinish: '/img/hyrox-run-finish.jpg',
  hxTeam: '/img/hyrox-team.jpg',
  heroSled: 'https://images.pexels.com/photos/20379134/pexels-photo-20379134.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=520&w=800',
  heroSled2: 'https://images.pexels.com/photos/26582396/pexels-photo-26582396.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=720&w=1100',
  functional: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?crop=entropy&cs=srgb&fm=jpg&q=80&w=1100',
  athlete1: 'https://images.unsplash.com/photo-1605296867304-46d5465a13f1?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  athlete2: 'https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  athlete3: 'https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  wallball: 'https://images.unsplash.com/photo-1757147517533-d82452a204d4?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  rowing: 'https://images.unsplash.com/photo-1519505907962-0a6cb0167c73?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  rowing2: 'https://images.pexels.com/photos/8611382/pexels-photo-8611382.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=560&w=800',
  kettlebell: 'https://images.unsplash.com/photo-1632077804406-188472f1a810?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  sandbag: 'https://images.unsplash.com/photo-1775322869909-08231a08f6e9?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  burpees: 'https://images.unsplash.com/photo-1739283180407-21e27d5c0735?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  running: 'https://images.unsplash.com/photo-1502904550040-7534597429ae?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  facility1: 'https://images.unsplash.com/photo-1775993167276-743bbcde77e1?crop=entropy&cs=srgb&fm=jpg&q=80&w=1100',
  facility2: 'https://images.pexels.com/photos/29224211/pexels-photo-29224211.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=720&w=1100',
  crossfit: 'https://images.unsplash.com/photo-1623874106686-5be2b325c8f1?crop=entropy&cs=srgb&fm=jpg&q=80&w=1100',
  facility4: 'https://images.pexels.com/photos/9545914/pexels-photo-9545914.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=720&w=1100',
  coach1: 'https://images.unsplash.com/photo-1549476464-37392f717541?crop=entropy&cs=srgb&fm=jpg&q=80&w=800',
  coach2: 'https://images.pexels.com/photos/16966301/pexels-photo-16966301.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700',
  // Portraits coachs N&B (générés depuis les vraies photos de l'équipe) — servis en local.
  coachTeva: '/img/coach-teva.jpg?v=2',
  coachAndreia: '/img/coach-andreia.jpg',
  coachEleo: '/img/coach-eleo.jpg?v=2',
  coachVincent: '/img/coach-vincent.jpg?v=2',
  coachAlexis: '/img/coach-alexis.jpg?v=2',
  coachRaihau: '/img/coach-raihau.jpg?v=2',
  coachGuillaume: '/img/coach-guillaume.jpg?v=2',
  coachQiu: '/img/coach-qiu.jpg?v=2',
  // Intérieurs réels des box avec bannière murale "HYBRID TRAINING CLUB".
  clubColomiers: '/img/club-colomiers.jpg',
  clubToulouse: '/img/club-toulouse.jpg',
  // Avatars témoignages — portraits visage accordés au genre du prénom.
  testiMarine: '/img/testi-marine.jpg',
  testiThomas: '/img/testi-thomas.jpg',
  testiSarah: '/img/testi-sarah.jpg',
};

// Cadrage (object-position) pour garder le visage / l'émotion visible sur les photos d'action.
export const IMG_FOCUS = {
  hxSledPush: 'center 38%', hxRameur: 'center 22%', hxSledPull: 'center 26%',
  hxSbLunges: 'center 24%', hxKbCarry: 'center 22%', hxSkierg: 'center 38%',
  hxRunStart: 'center 30%', hxRunFinish: 'center 30%', hxTeam: 'center 42%',
};

export const NAV_LINKS = [
  { label: 'Accueil', to: '/' },
  { label: "L'Hyrox", to: '/lhyrox' },
  { label: 'Nos cours', to: '/nos-cours' },
  {
    label: 'Nos clubs',
    to: '/club/toulouse',
    children: [
      { label: 'Hyrox Toulouse', to: '/club/toulouse' },
      { label: 'Hyrox Colomiers', to: '/club/colomiers' },
    ],
  },
  { label: "L'équipe", to: '/equipe' },
  { label: 'Tarifs', to: '/tarifs' },
];

export const STATS = [
  { value: '8', suffix: '', label: 'Stations Hyrox' },
  { value: '2', suffix: '', label: 'Salles dans Toulouse' },
  { value: '600', suffix: '+', label: 'Membres actifs' },
  { value: '29', suffix: '€', label: 'À partir de / mois' },
];

export const CONCEPT = {
  eyebrow: 'Hybrid concept',
  title: 'Venez comme vous êtes',
  text: "Les cours en effectif limité permettent de conserver la qualité du travail et un coaching réellement personnalisé. Que tu sois débutant ou compétiteur, tu progresses à ton rythme dans une communauté qui te tire vers le haut.",
  cards: [
    {
      title: "Qu'est-ce que l'Hyrox ?",
      text: "Découvre la nouvelle méthode d'entraînement qui mêle course et fonctionnel.",
      to: '/lhyrox',
      img: 'hxSledPush',
    },
    {
      title: 'Nos cours',
      text: 'Découvre nos différents types de cours encadrés par des coachs experts.',
      to: '/nos-cours',
      img: 'wallball',
    },
  ],
};

export const STATIONS = [
  { name: 'SkiErg', img: 'hxSkierg', desc: '1000m pour engager tout le haut du corps.' },
  { name: 'Sled Push', img: 'hxSledPush', desc: '50m de poussée de traîneau, full power.' },
  { name: 'Sled Pull', img: 'hxSledPull', desc: '50m de traction, dos et jambes.' },
  { name: 'Burpee Broad Jump', img: 'burpees', desc: '80m de burpees sauts, le cardio ultime.' },
  { name: 'Rowing', img: 'hxRameur', desc: '1000m rameur, rythme et endurance.' },
  { name: 'Farmers Carry', img: 'hxKbCarry', desc: '200m de port de charge lourde.' },
  { name: 'Sandbag Lunges', img: 'hxSbLunges', desc: '100m de fentes lestées.' },
  { name: 'Wall Balls', img: 'wallball', desc: '100 wall balls pour finir en beauté.' },
];

// Programmation universelle (tous niveaux), structurée en blocs complémentaires.
export const COURSES = [
  {
    name: 'Hyrox Simulation',
    img: 'hxSledPush',
    objectPos: 'center 38%',
    desc: "On reproduit les conditions du jour J : course et stations enchaînées — ou une version équivalente sur un format plus court.",
  },
  {
    name: 'Cardio',
    img: 'hxRameur',
    objectPos: 'center 22%',
    desc: "On construit ton moteur : course, rameur, SkiErg et bike pour tenir la distance.",
  },
  {
    name: 'Renfo haut du corps',
    img: 'hxSledPull',
    objectPos: 'center 26%',
    desc: "Charge sur le haut du corps, pour encaisser les obstacles les plus exigeants — grip compris.",
  },
  {
    name: 'Renfo bas du corps',
    img: 'hxSbLunges',
    objectPos: 'center 24%',
    desc: "Au poids du corps ou avec charge, pour tenir sur les obstacles qui brûlent les jambes.",
  },
  {
    name: 'Force',
    img: 'hxKbCarry',
    objectPos: 'center 22%',
    desc: "On apprend à déplacer du lourd pour répondre aux exigences de force des obstacles.",
  },
  {
    name: 'Conditioning',
    img: 'hxSkierg',
    objectPos: 'center 38%',
    desc: "Un format mixte façon CrossFit, avec les mouvements de l'Hyrox (ou leurs alternatives).",
  },
  {
    name: 'Hyrox Team',
    img: 'hxTeam',
    objectPos: 'center 42%',
    desc: "L'entraînement en équipe : intensité, cohésion et esprit de groupe.",
  },
];

export const CLUBS = {
  toulouse: {
    slug: 'toulouse',
    name: 'Hyrox Toulouse',
    city: 'Toulouse',
    tagline: 'Le hub Hyrox au cœur de la ville rose',
    address: '15 rue Humbert Tomatis, 31200 Toulouse',
    phone: '07 80 90 78 49',
    hero: 'clubToulouse',
    gallery: ['hxSledPush', 'hxSkierg', 'hxRameur'],
    features: ['8 stations Hyrox officielles', 'Espace running indoor', 'Coaching illimité', 'Vestiaires & douches'],
    schedule: [
      { day: 'Lundi', slots: ['06:30', '12:15', '18:00', '19:00'] },
      { day: 'Mardi', slots: ['06:30', '12:15', '18:00', '19:00'] },
      { day: 'Mercredi', slots: ['07:00', '12:15', '18:00', '19:00'] },
      { day: 'Jeudi', slots: ['06:30', '12:15', '18:00', '19:00'] },
      { day: 'Vendredi', slots: ['06:30', '12:15', '17:30', '18:30'] },
      { day: 'Samedi', slots: ['09:00', '10:30'] },
      { day: 'Dimanche', slots: ['10:00'] },
    ],
  },
  colomiers: {
    slug: 'colomiers',
    name: 'Hyrox Colomiers',
    city: 'Colomiers',
    tagline: 'Ton box Hyrox à deux pas de chez toi',
    address: '1 av. Didier Daurat / 17 av. Clément Ader, 31770 Colomiers',
    phone: '07 80 90 37 49',
    hero: 'clubColomiers',
    gallery: ['hxSledPull', 'hxSbLunges', 'hxKbCarry'],
    features: ['8 stations Hyrox officielles', 'Grand parking gratuit', 'Coaching illimité', 'Espace mobilité'],
    schedule: [
      { day: 'Lundi', slots: ['07:00', '12:00', '18:00', '19:00'] },
      { day: 'Mardi', slots: ['07:00', '12:00', '18:00', '19:00'] },
      { day: 'Mercredi', slots: ['07:00', '12:00', '18:00'] },
      { day: 'Jeudi', slots: ['07:00', '12:00', '18:00', '19:00'] },
      { day: 'Vendredi', slots: ['07:00', '12:00', '17:30'] },
      { day: 'Samedi', slots: ['09:30', '11:00'] },
      { day: 'Dimanche', slots: ['10:00'] },
    ],
  },
};

export const TEAM = [
  { name: 'Teva', role: 'Owner', img: 'coachTeva', bio: "Fondateur passionné, Teva a créé Hybrid pour réunir la communauté Hyrox toulousaine." },
  { name: 'Andreia', role: 'Owner', img: 'coachAndreia', bio: "Co-fondatrice de Hybrid, Andreia porte l'énergie et l'esprit communauté qui font vibrer le club." },
  { name: 'Eleo', role: 'Head Coach & Head Prog', img: 'coachEleo', bio: 'Cerveau de la programmation, Eleo conçoit chaque séance pour te faire progresser.' },
  { name: 'Vincent', role: 'Coach', img: 'coachVincent', bio: "Spécialiste de l'endurance et de la technique de course." },
  { name: 'Alexis', role: 'Coach', img: 'coachAlexis', bio: 'Force et explosivité : Alexis te pousse à dépasser tes limites.' },
  { name: 'Raihau', role: 'Coach', img: 'coachRaihau', bio: "Énergie et rigueur : Raihau accompagne chaque athlète vers son meilleur niveau." },
  { name: 'Guillaume', role: 'Commercial', img: 'coachGuillaume', bio: "Ton premier contact : Guillaume t'accueille, répond à toutes tes questions et te cale ta première séance." },
  { name: 'Qiu', role: 'Mascotte', img: 'coachQiu', bio: "Le bon gardien du box : Qiu veille sur la communauté Hybrid et distribue les câlins post-WOD." },
];

export const PRICING = [
  {
    name: '1X / SEMAINE',
    price: '29',
    period: '/ mois',
    highlight: false,
    tag: 'Engagement 12 mois',
    noCommit: '39€/mois sans engagement',
    features: ['1 séance par semaine', 'Accès à ta salle', 'Coaching en groupe', 'Application de suivi'],
  },
  {
    name: '2X / SEMAINE',
    price: '49',
    period: '/ mois',
    highlight: true,
    tag: 'Le plus choisi · Engagement 12 mois',
    noCommit: '59€/mois sans engagement',
    features: ['2 séances par semaine', 'Accès aux 2 salles', 'Coaching personnalisé', 'Suivi de performance', 'Communauté & events'],
  },
  {
    name: 'ILLIMITÉ',
    price: '69',
    period: '/ mois',
    highlight: false,
    tag: 'Engagement 12 mois',
    noCommit: '79€/mois sans engagement',
    features: ['Séances illimitées', 'Accès aux 2 salles', 'Open Gym inclus', 'Coaching premium', 'Hyrox offert si abonné CrossFit'],
  },
];

export const CARNETS = [
  { sessions: '5', price: '75', perSession: '15€ / séance' },
  { sessions: '10', price: '130', perSession: '13€ / séance' },
  { sessions: '20', price: '220', perSession: '11€ / séance' },
];

export const FAQ = [
  { q: 'Faut-il être sportif pour commencer ?', a: "Pas du tout ! Nos coachs adaptent chaque mouvement à ton niveau. Le format ROX est pensé pour les débutants." },
  { q: "Comment se passe la séance d'essai ?", a: "Tu réserves via le formulaire de contact, on te recontacte sous 24h pour caler ton créneau. La séance d'essai est offerte." },
  { q: 'Quelle est la différence entre Hyrox et CrossFit ?', a: "L'Hyrox combine course à pied et stations fonctionnelles standardisées, là où le CrossFit varie les WODs au quotidien. Nos salles proposent les deux." },
  { q: 'Y a-t-il un engagement ?', a: "L'abonnement Découverte est sans engagement. Tu es libre à tout moment." },
  { q: 'Puis-je accéder aux deux salles ?', a: "Oui, avec les formules Hybrid et Double Abo tu accèdes librement à Toulouse et Colomiers." },
];

export const TESTIMONIALS = [
  { name: 'Marine D.', role: 'Membre depuis 1 an', text: "J'ai bouclé ma première Hyrox grâce à Hybrid. Les coachs sont au top et l'ambiance est dingue !", img: 'testiMarine' },
  { name: 'Thomas L.', role: 'Compétiteur', text: "La meilleure prépa Hyrox de Toulouse. Stations officielles et prog ultra carrée.", img: 'testiThomas' },
  { name: 'Sarah K.', role: 'Débutante', text: "Je n'avais jamais fait de sport, aujourd'hui je m'entraîne 3x par semaine. Merci l'équipe !", img: 'testiSarah' },
];
